import { loadView } from '@/router'

export default [
  {
    path: 'freight',
    name: 'reports-freight',
    component: loadView('Application/Reports/Freight'),
    showInAlfred: true,
    alfredTitle: 'Reports - Freight'
  }
]
